const routesWithExternalClickjackProtection = [
  ":instCode/manager/modules/:moduleId/lti",
  ":instCode/lti-authentication",
];

export default routesWithExternalClickjackProtection;
